import produce from 'immer';
import cloneDeep from 'lodash/cloneDeep';

import { DEFAULT_CAMPAIGN_STATE } from '../constants';
import { createReducer } from 'utils/redux';

import {
  CcmCampaignFormCreatorlessAction,
  CcmCampaignFormCreatorlessState
} from '../types';

const INITIAL_STATE: CcmCampaignFormCreatorlessState = {
  form: cloneDeep(DEFAULT_CAMPAIGN_STATE),
  errors: [],
  submittionState: { type: 'none' },
  timeline: null,
  regions: []
};

export default createReducer<CcmCampaignFormCreatorlessState, CcmCampaignFormCreatorlessAction>(
  'ccmCampaignFormCreatorless',
  cloneDeep(INITIAL_STATE),
  {
    'creatorless-campaign-countries-update': (state, { countries }) => produce(state, draft => {
      draft.form.countries = countries;
    }),
    'creatorless-campaign-gender-update': (state, { gender }) => produce(state, draft => {
      draft.form.gender = gender;
    }),
    'creatorless-campaign-go-live-date-update': (state, { date }) => produce(state, draft => {
      draft.form.goLiveDate = date;
    }),
    'creatorless-campaign-name-update': (state, { name }) => produce(state, draft => {
      draft.form.name = name;
    }),
    'creatorless-campaign-package-update': (state, { pkg }) => produce(state, draft => {
      draft.form.package = pkg;
    }),
    'creatorless-campaign-zalando-link-update': (state, { link }) => produce(state, draft => {
      draft.form.zalandoLink = link;
    }),
    'creatorless-campaign-timeline-update': (state, { timeline }) => produce(state, draft => {
      draft.timeline = timeline;
    }),
    'creatorless-campaign-regions-update': (state, { regions }) => produce(state, draft => {
      draft.regions = regions;
    }),
    'creatorless-campaign-form-from-campaign-update': (state, { form }) => produce(state, draft => {
      draft.form = form;
    }),
    'creatorless-campaign-form-submittion-state-update': (state, { submittionState }) => produce(state, draft => {
      draft.submittionState = submittionState;
    }),
    'creatorless-campaign-flush': (state) => produce(state, draft => {
      const updatedState: CcmCampaignFormCreatorlessState = cloneDeep(INITIAL_STATE);

      Object.keys(updatedState).forEach(key => {
        draft[key] = updatedState[key];
      });
    })
  }
);
